module.exports = __webpack_public_path__ + "static/media/Dr.jengu-logo.2f228240.png";